export default [
  {
    path: '/activity-20260430-main',
    component: () => import('./Page.vue'),
    meta: { title: '五一心动环游记', id: 28 },
  },
  {
    path: '/activity-20260430-rule',
    component: () => import('./Rule.vue'),
    meta: { title: '五一心动环游记-规则', id: 28 },
  },
]
